import { authMethod } from '../secure-portal/auth/Auth.constants';
import { Environment } from './environment.types';

const environment: Partial<Environment> = {
  apiBaseUrl: 'https://development-qms-api.sierralabs.io/api/',
  siteDomain: 'development-qms.sierralabs.io',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  secure: true,
  tinyApiKey: '28wr7ysrep8u469n6qqpzvzmn9uyye4phxcstpwrtdh6blk1',
  recaptchaSiteKey: '6LfLJtQjAAAAAF5Eymo01VfMF2qxtY7C1r8j-MxT',
  changeOrderConfig: {
    useCustomFields: true,
    enableQualityChangeFields: true,
    useMarsbioForm: true
  },
  authConfig: {
    methods: [authMethod.default, authMethod.google, authMethod.okta]
    // defaultId: authMethod.okta.id // default to Okta auth
  },
  fileConfig: { showChangeOrderV2ReferenceCard: true },
  organizationConfig: { enabled: true },
  hazardConfig: { isBasicOptions: true }
};

export default environment;
